export default async function getCollection(ref) {
	const documents = [];

	const snapshot = await ref.get();

	snapshot.forEach((doc) => documents.push(doc));

	return documents;
}
